import * as ko from "knockout";
import {IParams as IAbstractParams, PermissionCellAbstract} from "./AbstractCell";
import {ErrorTracker} from "../../../../error.tracker";
import {getPermissionDisplayName, isNullOrUndefinedOrEmptyString} from "../../../../util/misc";
import {ISystemRole} from "../../../../index";
import {IComboboxV2Options} from "../../../combobox/v2";
import {lm} from "../../../../appContext";
import {KOSubscriptionTracker} from "../../../../util/KOSubscriptionTracker";
import {SYSTEM_MEGA_EADM} from "../../../../constants";
import {nsTooltip} from "../../../../util/nsTooltip";
import roleHtml from './role.html?raw';

export let template = roleHtml;

interface IParams extends IAbstractParams {
    errorTracker: ErrorTracker
}

export class viewModel extends PermissionCellAbstract {

    private errorTracker: ErrorTracker;
    private kosub: KOSubscriptionTracker = new KOSubscriptionTracker()

    constructor(params: IParams) {
        super(params);
        this.errorTracker = params.errorTracker;
    }

    private getPermissionDisplayName(role: ISystemRole): string {
        const system = this.params.sp.system();
        return system ? (getPermissionDisplayName(role, system) ?? '') : '';
    }

    private getComboboxSystemRoleParams(): IComboboxV2Options<ISystemRole> | null {
        const system = this.sp.system();
        if (!system) {
            return null;
        }
        const data: KnockoutObservableArray<ISystemRole> = ko.observableArray(system.roles ?? [])
        this.kosub.subscribeChanged(this.sp.system, (o) => {
            data(o?.roles ?? [])
        })
        return {
            inputAttrs: {placeholder: lm.t('choose permission|td') ?? ''},
            data: data,
            enable: () => !!data().length,
            initialMatch: o => o.id == this.sp.role()?.id,
            option: {
                label: this.getPermissionDisplayName.bind(this),
                sortBy: [(o) => {
                    const currentSystem = this.sp.system();
                    if (currentSystem?.name == SYSTEM_MEGA_EADM) {
                        return o.roleenum
                    }
                    return o.name.toLowerCase()
                }],
                tooltip: o => {
                    const currentSystem = this.sp.system();
                    return currentSystem && o ? lm.t(nsTooltip.getTitle_role(currentSystem, o) ?? '') ?? '' : '';
                },
            },
            onSelect: o => {
                const a = !!o?.metadata
                const b = !this.sp.comment()
                if (a && b) {
                    this.sp.toggleOpenComment(true)
                    this.sp.comment(o.metadata ?? null)
                }
            },
            selected: this.sp.role,
            title: o => {
                const currentSystem = this.sp.system();
                return currentSystem && o ? lm.t(nsTooltip.getTitle_role(currentSystem, o) ?? '') ?? '' : '';
            },
            inputStatus: (selected, text) => !!selected && !!text ? 'ok' : 'warning',
        }
    }

    dispose() {
        this.kosub.unsuscribeAll()
    }

}
